module.exports = __webpack_public_path__ + "static/media/totalSavedIcon.8ccfc3ff.svg";